import {
  Box,
  FormGroup,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import AppButton from "components/CustomButtons/AppButton";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
// import { useDispatch } from 'react-redux';
import useResponsiveFontSize from "views/User/OnBoard/Company/responseFonSize";
import visaIcon from "../../../../assets/img/visa_icon.png";
import masterCardIcon from "../../../../assets/img/mastercard_icon.png";
import americanExpressIcon from "../../../../assets/img/american_express_icon.png";
import dinnerClubIcon from "../../../../assets/img/club_diners_icon.png";
import discoverIcon from "../../../../assets/img/discover_icon.png";
import jcbIcon from "../../../../assets/img/jcb_icon.png";
import unionPayIcon from "../../../../assets/img/unionpay_icon.png";
import AppColor from "utilities/AppColor";
import classNames from "classnames";
// import PropTypes from "prop-types";
// import { reduceUpdateCardInfo } from 'store/slices/company';
import AppInput from "components/Input/AppInput";
import * as Yup from "yup";
import { fetchCompanyDetail } from "store/slices/company";
import { useDispatch, useSelector } from "react-redux";
import { getAuthInfo } from "store/slices/auth";
import { reduceUpdateCardInfo } from "store/slices/company";
import AppConfig from "config/AppConfig";
import PropTypes from "prop-types";

const { PATTERNS } = AppConfig;
// import { fetchCompanyDetail } from 'store/slices/company';
const ListCard = [
  // {
  //   id: 1,
  //   value: "UNKNOWN",
  //   icon: unknowCardIcon,
  // },
  {
    id: 1,
    value: "VISA",
    icon: visaIcon,
  },
  {
    id: 2,
    value: "MASTERCARD",
    icon: masterCardIcon,
  },
  {
    id: 3,
    value: "AMERICAN_EXPRESS",
    icon: americanExpressIcon,
  },
  {
    id: 4,
    value: "DINERS_CLUB",
    icon: dinnerClubIcon,
  },
  {
    id: 5,
    value: "DISCOVER",
    icon: discoverIcon,
  },
  {
    id: 6,
    value: "JCB",
    icon: jcbIcon,
  },
  {
    id: 7,
    value: "UNIONPAY",
    icon: unionPayIcon,
  },
];
const useStyles = makeStyles(() => ({
  control: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: "1rem",
  },
  title: {
    display: "flex",
    margin: "2rem 0 0 0",
    "& h5": {
      color: AppColor.black,
    },
  },
  listCard: {
    display: "flex",
    justifyContent: "center",
  },
  box: {
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.15), inset 0px 4px 4px rgba(0, 0, 0, 0.15)",
    borderRadius: "20px",
    marginBottom: "20px",
    padding: "10px",
    marginTop: '20px'
  },
  link: {
    color: "#277BC9",
    cursor: "pointer",
  },
}));

const useOptions = () => {
  const fontSize = useResponsiveFontSize();
  const options = useMemo(
    () => ({
      hidePostalCode: true,
      style: {
        base: {
          fontSize: "16px",
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#9e2146",
        },
      },
    }),
    [fontSize]
  );

  return options;
};
const CardInformationForm = (props) => {
  const {
    setOpenEdit,
    isOpenEdit
  } = props;
  const stripe = useStripe();

  const options = useOptions();
  const { t } = useTranslation();
  const elements = useElements();
  const classes = useStyles();
  const dispatch = useDispatch();
  // const [isOpenEdit, setOpenEdit] = useState(false);
  const [errorCard, setErrorCard] = useState("");
  const [companyInfo, setCompanyInfo] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { cardNumber, cardType, cardExpDate, cardHolder } = companyInfo;
  const userInfo = useSelector(getAuthInfo);

  const { companyId } = userInfo;

  const handleUpdateCardInfo = async ({ cardHolder }) => {
    // setOpenEdit(false);
    setIsSubmitting(true);
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    const cardElement = elements.getElement("card");
    const result = await stripe
      .createToken(cardElement)
      .then((payload) => {
        if (payload && payload.token && payload.token.id) {
          return payload.token.id;
        }
        if (payload.error && payload.error.message) {
          setErrorCard(payload.error.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    if (result) {
      const request = {
        cardHolder: cardHolder,
        cardToken: result,
        companyId: companyId,
      };
      const { payload } = await dispatch(reduceUpdateCardInfo(request));
    setIsSubmitting(false);
      if (payload) {
        setOpenEdit(false)
        _loadData();
      }
    }
    setIsSubmitting(false);
  };

  const _loadData = async () => {
    const { payload } = await dispatch(
      fetchCompanyDetail({ companyId: companyId })
    );
    if (payload) {
      const _companyInfo = payload.company;
      setCompanyInfo(_companyInfo);
    }
  };
  useEffect(() => {
    _loadData();
  }, []);
  return (
    <Formik
      initialValues={{
        cardHolder: cardHolder ? cardHolder : "",
      }}
      validationSchema={Yup.object().shape({
        cardHolder: Yup.string().required("validation.required").max(255, "validation.max_length_255").matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces').nullable(),
      })}
      onSubmit={handleUpdateCardInfo}
      enableReinitialize
    >
      {({ setFieldValue }) => (
        <Form style={{ width: "100%" }}>
          <Grid container spacing={3} className={classes.box}>
            <Grid item xs={12} md={12}>
              <Box
                className={classNames({
                  [classes.title]: true,
                  "mt-0": true,
                })}
              >
                <Typography variant="h5">
                  {t("title.card_information")}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <Box className={classes.listCard}>
                {ListCard.map((card) => (
                  <img
                    key={`${card.id}-img`}
                    src={card.icon}
                    style={{ width: "40px", marginRight: "20px" }}
                  />
                ))}
              </Box>
            </Grid>
            <Grid item xs={6} md={6}>
              {cardHolder && <Field
                component={AppInput}
                name="cardHolder"
                id="cardHolder"
                label={"label.cardHolder"}
                disabled={!isOpenEdit}
              />}
            </Grid>
            <Grid item xs={6} md={6}>
              <FormGroup style={{ marginTop: 3 }}>
                <label>{t("label.cardNumber")}</label>
                <div
                  className="w-100"
                  style={{
                    display: !isOpenEdit ? "flex" : "",
                    height: "40px",
                    border: errorCard
                      ? "1px solid #dc3545"
                      : "1px solid rgba(0, 0, 0, 0.2)",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
                    boxSizing: "border-box",
                    marginBottom: "10px",
                    backgroundColor: !isOpenEdit && cardNumber ? "#E9ECEF" : "",
                    padding:
                      !isOpenEdit && cardNumber
                        ? "0px 0px 0px 10px"
                        : "7px 0px 0px 20px",
                  }}
                >
                  {!isOpenEdit &&
                    cardNumber &&
                    cardType &&
                    ListCard.map((card) => {
                      if (card.value === cardType) {
                        return (
                          <React.Fragment key={card.id}>
                            <img
                              key={`${card.id}-img`}
                              src={card.icon}
                              style={{ width: "40px" }}
                            />
                            <div
                              style={{
                                display: "inline-block",
                                width: "90%",
                                fontSize: "16px",
                                height: 30,
                                marginTop: '5px',
                                marginLeft: '20px'
                              }}
                            >
                              <Grid container style={{width: 'auto', height: '30px'}}>
                                <Grid item xs={6} >
                                  <span>{`****  ****  ${cardNumber}`}</span>
                                </Grid>
                                <Grid item xs={5} style={{ textAlign: "end" }}>
                                  <span>{cardExpDate}</span>
                                </Grid>
                              </Grid>
                            </div>
                          </React.Fragment>
                        );
                      }
                    })}
                  {isOpenEdit && (
                    <CardElement
                      options={options}
                      // onReady={() => {
                      //   console.log("CardElement [ready]");
                      // }}
                      onChange={(event) => {
                        if (event.error && event.error.message) {
                          setErrorCard(event.error.message);
                        } else {
                          setErrorCard("");
                        }
                        // console.log("CardElement [change]", event);
                      }}
                      // onBlur={() => {
                      //   console.log("CardElement [blur]");
                      // }}
                      // onFocus={() => {
                      //   console.log("CardElement [focus]");
                      // }}
                    />
                  )}
                </div>
                <div
                  style={{
                    color: "#dc3545",
                    marginBottom: "10px",
                    fontSize: "80%",
                  }}
                >
                  <span>{errorCard}</span>
                </div>
              </FormGroup>
            </Grid>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {!isOpenEdit && (
                <AppButton
                  label={t("label.change")}
                  rounder
                  type="button"
                  onClick={() => {
                    setOpenEdit(true);
                  }}
                />
              )}
              {isOpenEdit && (
                <>
                  <AppButton
                    label={t("button.save")}
                    rounder
                    type="submit"
                    style={{
                      marginRight: "10px",
                    }}
                    disabled={isSubmitting}
                  />
                  <AppButton
                    label={t("button.cancel")}
                    rounder
                    type="button"
                    buttonColor={'grey'}
                    onClick={() => {
                      setOpenEdit(false);
                      setFieldValue("cardHolder", cardHolder);
                      setErrorCard('');
                    }}
                    disabled={isSubmitting}
                  />
                </>
              )}
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

CardInformationForm.propTypes = { 
  setOpenEdit: PropTypes.any,
  isOpenEdit: PropTypes.bool

}
export default CardInformationForm;
